// src/components/ConfirmEmail.js

import React from 'react';

const ConfirmEmail = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">
      <div className="p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center text-blue-800">Confirm Your Email</h2>
        <p className="mt-4 text-center text-gray-700">
          A confirmation email has been sent to your email address. Please check your inbox and follow the instructions to verify your account.
        </p>
      </div>
    </div>
  );
};

export default ConfirmEmail;
